/**
 * Gradient blur overlay at the top of the chat modal.
 * Makes messages fade out smoothly behind the status bar and top buttons.
 */

import { LinearGradient } from 'expo-linear-gradient';
import { StyleSheet } from 'react-native';

interface ChatTopBlurProps {
  /** Total height of the fade zone (status bar + button row + extra). */
  height: number;
}

export function ChatTopBlur({ height }: ChatTopBlurProps) {
  return (
    <LinearGradient
      colors={[
        'rgba(0, 0, 0, 0.30)',
        'rgba(0, 0, 0, 0.28)',
        'rgba(0, 0, 0, 0.22)',
        'rgba(0, 0, 0, 0.10)',
        'rgba(0, 0, 0, 0)',
      ]}
      locations={[0, 0.3, 0.6, 0.85, 1]}
      style={[styles.gradient, { height }]}
      pointerEvents="none"
    />
  );
}

const styles = StyleSheet.create({
  gradient: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 5,
  },
});
